export default __webpack_public_path__ + "static/media/AvatarCardIcon.1f99213e.svg";